import React from 'react';

const pillars = [
  { tag: 'BUYER INTENT AI', t: 'Smart Segmentation', b: 'DSP-powered behavioral clustering segments visitors by purchase intent, product affinity, and engagement depth — not demographics.' },
  { tag: 'DCO ENGINE', t: 'Dynamic Creative Optimization', b: "Every ad is built on-the-fly from the shopper's specific browsing behavior. Unlimited multivariate A/B testing runs continuously." },
  { tag: 'REAL-TIME RTB', t: 'Proactive Bidding', b: 'Real-time bid management powered by 100+ data inputs: visitor signals, inventory availability, competitive pressure, device context.' },
  { tag: 'ATTRIBUTION AI', t: 'Full-Funnel Attribution', b: 'Every sale is verified, de-duplicated, and attributed with precision. Our model connects impressions to revenue with zero ambiguity.' },
];

export default function TechPillarsSection() {
  return (
    <section className="highlights-section" id="tech-stack" data-testid="tech-section">
      <div className="highlights-glow highlights-glow-one" />
      <div className="highlights-glow highlights-glow-two" />
      <div className="container-r360">
        <div className="highlights-kicker">
          <span />TECHNOLOGY PLATFORM
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 xl:gap-10 md:gap-6 items-start">
          <h2 className="reveal-on-scroll lg:col-span-7 font-display text-[3.25rem] sm:text-[4.5rem] xl:text-[5.75rem] font-bold leading-[0.92] tracking-[-0.03em] text-[#262626]">
            Four Pillars. One <span className="text-[#60a5fa]">Unfair</span> Advantage.
          </h2>
          <div className="lg:col-span-5">
            <p className="reveal-on-scroll sec-subhead leading-relaxed">
              Our proprietary performance stack unifies AI intent modeling, creative automation, real-time bidding, and revenue attribution into one fully managed retargeting engine—built to convert smarter, scale faster, and maximise every advertising dollar spent.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-[#1a1a1a] mt-8 lg:mt-12">
          {pillars.map((p, i) => (
            <div key={i} className="p-5 lg:p-7 border-r border-b border-[#1a1a1a] group transition-colors bg-white/70">
              <div className="text-[1rem] font-mono font-bold text-[#ff5117] mb-2">{p.tag}</div>
              <div className="font-display text-[26px] lg:text-[32px] font-bold mb-2 lg:mb-4 text-[#262626] leading-[1.25]">{p.t}</div>
              <p className="sec-subhead leading-relaxed max-w-lg">{p.b}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 lg:mt-10 flex flex-wrap gap-2 md:gap-5 lg:gap-8 justify-between font-bold">
          <span>▪ Cookieless Compatible</span>
          <span>▪ Integrates TTD · DV360 · XANDR</span>
          <span>▪ GDPR + CCPA By Design</span>
        </div>
      </div>
    </section>
  );
}
